import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { isDark } = useTheme();
  const { t } = useLanguage();
  
  return (
    <footer className="border-t border-theme mt-auto bg-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold tracking-tight text-[color:var(--color-primary)]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                <span style={{ color: 'var(--color-logo-gold)' }}>Ô'</span>Délicieuse <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[color:var(--color-emerald)] align-middle ml-1" style={{ fontFamily: 'Manrope, sans-serif' }}>Wholesale</span>
              </span>
            </Link>
            <p className="text-muted text-sm leading-relaxed max-w-md">
              {t('footer_desc')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-heading text-xs font-bold uppercase tracking-widest mb-4">{t('footer_navigation')}</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-sm">{t('nav_home')}</Link>
              <Link to="/catalogue" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-sm">{t('nav_catalogue')}</Link>
              <Link to="/panier" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-sm">{t('cart_title')}</Link>
              <Link to="/connexion" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-sm">{t('nav_login')}</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-heading text-xs font-bold uppercase tracking-widest mb-4">{t('footer_contact')}</h4>
            <div className="flex flex-col gap-3">
              <a 
                href="https://wa.me/32493328862" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-muted hover:text-[color:var(--color-primary)] transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                +32 493 32 88 62
              </a>
              <div className="flex items-center gap-2 text-muted text-sm">
                <MapPin className="w-4 h-4" />
                Belgique
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-theme mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted text-xs">
            © {new Date().getFullYear()} Ô'Délicieuse Wholesale. {t('footer_rights')}
          </p>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-2 justify-center">
            <Link to="/mentions-legales" data-testid="footer-mentions-link" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-xs uppercase tracking-wider">
              Mentions légales
            </Link>
            <Link to="/cgv" data-testid="footer-cgv-link" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-xs uppercase tracking-wider">
              CGV
            </Link>
            <Link to="/confidentialite" data-testid="footer-privacy-link" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-xs uppercase tracking-wider">
              Confidentialité
            </Link>
            <Link to="/cookies" data-testid="footer-cookies-link" className="text-muted hover:text-[color:var(--color-primary)] transition-colors text-xs uppercase tracking-wider">
              Cookies
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
